import React, { useEffect } from 'react'
import { FunctionComponent, SVGProps } from 'react'
import { OutboundContainer, StyledSpan } from '../styled'
import { SpanWrapper, SizedSvg } from './style'
import styled from 'styled-components'
const TICK_DURATION = 750

type TooltipTextProps = {
  contextualFeedback?: string
  textOffset?: string
  text: string
  clickedTextOffset?: string
  icon: FunctionComponent<SVGProps<SVGSVGElement>>
  action: () => void
}

export const StyledContextualIconContainer = styled.div`
  width: 12px;
  height: 12px;
`

/**
 * React component that shows text when mouse hovers over it
 */
const TooltipText: React.FC<TooltipTextProps> = ({
  contextualFeedback,
  text,
  icon,
  action,
  textOffset,
  clickedTextOffset,
}) => {
  const [showText, setShowText] = React.useState(false)
  const [clicked, setClicked] = React.useState(false)
  const mouseIn = () => setShowText(true)
  const mouseOut = () => setShowText(false)

  const handleClick = () => {
    action()
    setClicked(true)
  }

  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (clicked) {
      timeout = setTimeout(() => {
        setClicked(false)
      }, TICK_DURATION)
    }
    return () => clearTimeout(timeout)
  }, [clicked])
  const textToRender = clicked ? contextualFeedback : text
  return (
    <OutboundContainer
      showText={showText}
      onMouseLeave={mouseOut}
      onMouseEnter={mouseIn}
      onClick={handleClick}
    >
      <SizedSvg icon={icon} />
      <SpanWrapper textOffset={clicked ? clickedTextOffset : textOffset}>
        <StyledSpan showText={showText}>{textToRender}</StyledSpan>
      </SpanWrapper>
    </OutboundContainer>
  )
}
export default TooltipText
